import { createReducer } from "@reduxjs/toolkit";
import { PermitsState } from "../../actions/regulation/Permits/types";
import { showPermitsListView, showPermitsBatchListView } from "actions/regulation/Permits";

const initialState: PermitsState = {
    showPermitsListView: false,
    showPermitsBatchListView: false,
    selectedColumns: []
};

const Permits = createReducer(initialState, (builder) => {
    builder
        .addCase(showPermitsListView, (state, action) => {
            state.showPermitsListView = action.payload.showPermitsListView;
        })
        .addCase(showPermitsBatchListView, (state, action) => {
            state.showPermitsBatchListView = action.payload.showPermitsBatchListView;
        })
        .addDefaultCase((state) => state);
});

export default Permits;
